module.exports = __webpack_public_path__ + "static/media/app.98533b34.svg";